import {forwardRef} from 'react';

import styled from 'styled-components';

import type {WithDomStyleProp} from '../../utils/utility-types';
import type {Props, Ref, StyledProps} from './types';

import {TextInput} from '../TextInput';
import {web} from './styles';

const StyledTextArea = styled(TextInput)<
  Omit<StyledProps, 'autoCorrect'> & {autoCorrect: 'no' | 'yes' | undefined}
>`
  ${web}
`;

const TextArea = forwardRef<Ref, WithDomStyleProp<Props>>(
  ({children, ...rest}, ref) => {
    const normalizedAutoCorrect =
      rest.autoCorrect === undefined
        ? undefined
        : rest.autoCorrect
          ? 'yes'
          : 'no';

    return (
      // @ts-expect-error: refs mismatch
      <StyledTextArea
        {...rest}
        autoCorrect={normalizedAutoCorrect}
        forwardedAs="textarea"
        ref={ref}
      >
        {children}
      </StyledTextArea>
    );
  },
);

export {TextArea};
